import React, { useEffect, useState } from "react";
import { Card } from "@/components/ui/card";
import { Activity, Loader2 } from "lucide-react";
import { adminApi } from "@/lib/api";

export default function AdminSystem() {
  const [health, setHealth] = useState(null);
  useEffect(() => {
    const load = () => adminApi.get("/admin/health").then((r) => setHealth(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);
  if (!health) return <div className="py-16 text-center"><Loader2 className="w-6 h-6 animate-spin mx-auto" style={{ color: "#7C3AED" }} /></div>;
  return (
    <div className="space-y-6">
      <div><h1 className="text-2xl font-bold font-display">System Health</h1><p className="text-sm text-slate-500">Live status of every platform service (auto-refreshes every 30s).</p></div>
      <Card className="border shadow-none p-5">
        <div className="flex items-center gap-2 mb-4 text-emerald-600 font-semibold"><Activity className="w-5 h-5" /> All Systems Operational</div>
        <div className="grid md:grid-cols-2 gap-3">
          {health.services.map((s) => (
            <div key={s.name} className="flex items-center justify-between border rounded-lg px-4 py-3" data-testid="admin-service-row">
              <div className="flex items-center gap-2"><span className="w-2.5 h-2.5 rounded-full bg-emerald-500" /><span className="text-sm font-medium">{s.name}</span></div>
              <span className="text-sm text-slate-500 capitalize">{s.status} · {s.uptime}%</span>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
